//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    created() {
        window.addEventListener('keydown', (e) => {
            if (e.keyCode == 37 && this.enablePrev) {
                // left
                this.moveIndex(-1);
                this.submitPage;
            }

            if (e.keyCode == 39 && this.enableNext) {
                //right
                this.moveIndex(1);
                this.submitPage;
            }
        })
    },
    methods: {
        checkPaginationVisibility(i) {
            let cp = this.currentPage;
            let tp = this.results.totalPages;

            if (tp <= 9) return true;
            if (i === 0) return true
            if (i === tp - 1) return true

            if (cp < 4) {
                if (i < 4) return true;
            }

            if (Math.abs(cp - i) <= 2) return true

            if (cp > tp - 5) {
                if (i > tp - 5) return true;
            }

            return false;
        },
        selectIndex: function (index) {
            this.pIndex = index;
            this.submitPage();
        },
        moveIndex: function (increment) {
            this.pIndex += increment;
            this.submitPage();
        },
        submitPage: function () {
            this.$emit('submitPage', this.pIndex);
        },
        resetIndex: function () {
            this.pIndex = 0;
        }

    },
    data: function () {
        return {
            pIndex: 0
        }
    },
    mounted() {
        this.pIndex = this.query.currentPage;
    },
    computed: {    
        currentPage() {
            return this.query.currentPage;
        },
        settings: function () {
            return this.$store.state.settings;
        },
        enablePrev: function () {
            return this.pIndex > 0;
        },
        enableNext: function () {
            return this.pIndex + 1 < this.results.totalPages;
        },
        results: function () {
            return this.$store.state.results;
        },
        query: function () {
            return this.$store.state.searchQuery;
        }
    }
}
